import { jsx as u, jsxs as M } from "react/jsx-runtime";
import * as s from "react";
import { useState as ee, isValidElement as te } from "react";
import { O as re } from "./index-DiWzAyMV.js";
import { a as oe, c as x } from "./index-eoE_jzLb.js";
import { u as B, a as ne } from "./index-DoOsnuB6.js";
import { P as F, c as se } from "./index-D8UDu4KA.js";
import { A as ae, R as ie, c as V, a as le, D as ce, C as ue, P as pe } from "./index-C18TsXFG.js";
import { u as de } from "./index-n3ZmtxN0.js";
import { P as j } from "./index-CRtCLpV2.js";
import { c as $ } from "./clsx-OuTLNxxd.js";
import { B as fe } from "./Button-DIvSLTPg.js";
import './Tooltip.css';var ve = "VisuallyHidden", q = s.forwardRef(
  (t, r) => /* @__PURE__ */ u(
    F.span,
    {
      ...t,
      ref: r,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...t.style
      }
    }
  )
);
q.displayName = ve;
var he = q, [O] = se("Tooltip", [
  V
]), A = V(), U = "TooltipProvider", me = 700, L = "tooltip.open", [Te, N] = O(U), Y = (t) => {
  const {
    __scopeTooltip: r,
    delayDuration: e = me,
    skipDelayDuration: o = 300,
    disableHoverableContent: n = !1,
    children: a
  } = t, [l, v] = s.useState(!0), i = s.useRef(!1), d = s.useRef(0);
  return s.useEffect(() => {
    const c = d.current;
    return () => window.clearTimeout(c);
  }, []), /* @__PURE__ */ u(
    Te,
    {
      scope: r,
      isOpenDelayed: l,
      delayDuration: e,
      onOpen: s.useCallback(() => {
        window.clearTimeout(d.current), v(!1);
      }, []),
      onClose: s.useCallback(() => {
        window.clearTimeout(d.current), d.current = window.setTimeout(
          () => v(!0),
          o
        );
      }, [o]),
      isPointerInTransitRef: i,
      onPointerInTransitChange: s.useCallback((c) => {
        i.current = c;
      }, []),
      disableHoverableContent: n,
      children: a
    }
  );
};
Y.displayName = U;
var D = "Tooltip", [ye, _] = O(D), W = (t) => {
  const {
    __scopeTooltip: r,
    children: e,
    open: o,
    defaultOpen: n = !1,
    onOpenChange: a,
    disableHoverableContent: l,
    delayDuration: v
  } = t, i = N(D, t.__scopeTooltip), d = A(r), [c, f] = s.useState(null), m = de(), p = s.useRef(0), h = l ?? i.disableHoverableContent, y = v ?? i.delayDuration, T = s.useRef(!1), [C = !1, g] = oe({
    prop: o,
    defaultProp: n,
    onChange: (G) => {
      G ? (i.onOpen(), document.dispatchEvent(new CustomEvent(L))) : i.onClose(), a == null || a(G);
    }
  }), b = s.useMemo(() => C ? T.current ? "delayed-open" : "instant-open" : "closed", [C]), P = s.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, T.current = !1, g(!0);
  }, [g]), E = s.useCallback(() => {
    window.clearTimeout(p.current), p.current = 0, g(!1);
  }, [g]), S = s.useCallback(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      T.current = !0, g(!0), p.current = 0;
    }, y);
  }, [y, g]);
  return s.useEffect(() => () => {
    p.current && (window.clearTimeout(p.current), p.current = 0);
  }, []), /* @__PURE__ */ u(ie, { ...d, children: /* @__PURE__ */ u(
    ye,
    {
      scope: r,
      contentId: m,
      open: C,
      stateAttribute: b,
      trigger: c,
      onTriggerChange: f,
      onTriggerEnter: s.useCallback(() => {
        i.isOpenDelayed ? S() : P();
      }, [i.isOpenDelayed, S, P]),
      onTriggerLeave: s.useCallback(() => {
        h ? E() : (window.clearTimeout(p.current), p.current = 0);
      }, [E, h]),
      onOpen: P,
      onClose: E,
      disableHoverableContent: h,
      children: e
    }
  ) });
};
W.displayName = D;
var k = "TooltipTrigger", X = s.forwardRef(
  (t, r) => {
    const { __scopeTooltip: e, ...o } = t, n = _(k, e), a = N(k, e), l = A(e), v = s.useRef(null), i = B(r, v, n.onTriggerChange), d = s.useRef(!1), c = s.useRef(!1), f = s.useCallback(() => d.current = !1, []);
    return s.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ u(le, { asChild: !0, ...l, children: /* @__PURE__ */ u(
      F.button,
      {
        "aria-describedby": n.open ? n.contentId : void 0,
        "data-state": n.stateAttribute,
        ...o,
        ref: i,
        onPointerMove: x(t.onPointerMove, (m) => {
          m.pointerType !== "touch" && !c.current && !a.isPointerInTransitRef.current && (n.onTriggerEnter(), c.current = !0);
        }),
        onPointerLeave: x(t.onPointerLeave, () => {
          n.onTriggerLeave(), c.current = !1;
        }),
        onPointerDown: x(t.onPointerDown, () => {
          d.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: x(t.onFocus, () => {
          d.current || n.onOpen();
        }),
        onBlur: x(t.onBlur, n.onClose),
        onClick: x(t.onClick, n.onClose)
      }
    ) });
  }
);
X.displayName = k;
var H = "TooltipPortal", [ge, Ce] = O(H, {
  forceMount: void 0
}), K = (t) => {
  const { __scopeTooltip: r, forceMount: e, children: o, container: n } = t, a = _(H, r);
  return /* @__PURE__ */ u(ge, { scope: r, forceMount: e, children: /* @__PURE__ */ u(j, { present: e || a.open, children: /* @__PURE__ */ u(pe, { asChild: !0, container: n, children: o }) }) });
};
K.displayName = H;
var w = "TooltipContent", z = s.forwardRef(
  (t, r) => {
    const e = Ce(w, t.__scopeTooltip), { forceMount: o = e.forceMount, side: n = "top", ...a } = t, l = _(w, t.__scopeTooltip);
    return /* @__PURE__ */ u(j, { present: o || l.open, children: l.disableHoverableContent ? /* @__PURE__ */ u(J, { side: n, ...a, ref: r }) : /* @__PURE__ */ u(xe, { side: n, ...a, ref: r }) });
  }
), xe = s.forwardRef((t, r) => {
  const e = _(w, t.__scopeTooltip), o = N(w, t.__scopeTooltip), n = s.useRef(null), a = B(r, n), [l, v] = s.useState(null), { trigger: i, onClose: d } = e, c = n.current, { onPointerInTransitChange: f } = o, m = s.useCallback(() => {
    v(null), f(!1);
  }, [f]), p = s.useCallback(
    (h, y) => {
      const T = h.currentTarget, C = { x: h.clientX, y: h.clientY }, g = Pe(C, T.getBoundingClientRect()), b = Ee(C, g), P = Re(y.getBoundingClientRect()), E = Oe([...b, ...P]);
      v(E), f(!0);
    },
    [f]
  );
  return s.useEffect(() => () => m(), [m]), s.useEffect(() => {
    if (i && c) {
      const h = (T) => p(T, c), y = (T) => p(T, i);
      return i.addEventListener("pointerleave", h), c.addEventListener("pointerleave", y), () => {
        i.removeEventListener("pointerleave", h), c.removeEventListener("pointerleave", y);
      };
    }
  }, [i, c, p, m]), s.useEffect(() => {
    if (l) {
      const h = (y) => {
        const T = y.target, C = { x: y.clientX, y: y.clientY }, g = (i == null ? void 0 : i.contains(T)) || (c == null ? void 0 : c.contains(T)), b = !_e(C, l);
        g ? m() : b && (m(), d());
      };
      return document.addEventListener("pointermove", h), () => document.removeEventListener("pointermove", h);
    }
  }, [i, c, l, d, m]), /* @__PURE__ */ u(J, { ...t, ref: a });
}), [we, be] = O(D, { isInside: !1 }), J = s.forwardRef(
  (t, r) => {
    const {
      __scopeTooltip: e,
      children: o,
      "aria-label": n,
      onEscapeKeyDown: a,
      onPointerDownOutside: l,
      ...v
    } = t, i = _(w, e), d = A(e), { onClose: c } = i;
    return s.useEffect(() => (document.addEventListener(L, c), () => document.removeEventListener(L, c)), [c]), s.useEffect(() => {
      if (i.trigger) {
        const f = (m) => {
          const p = m.target;
          p != null && p.contains(i.trigger) && c();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [i.trigger, c]), /* @__PURE__ */ u(
      ce,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: a,
        onPointerDownOutside: l,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: c,
        children: /* @__PURE__ */ M(
          ue,
          {
            "data-state": i.stateAttribute,
            ...d,
            ...v,
            ref: r,
            style: {
              ...v.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ u(ne, { children: o }),
              /* @__PURE__ */ u(we, { scope: e, isInside: !0, children: /* @__PURE__ */ u(he, { id: i.contentId, role: "tooltip", children: n || o }) })
            ]
          }
        )
      }
    );
  }
);
z.displayName = w;
var Q = "TooltipArrow", Z = s.forwardRef(
  (t, r) => {
    const { __scopeTooltip: e, ...o } = t, n = A(e);
    return be(
      Q,
      e
    ).isInside ? null : /* @__PURE__ */ u(ae, { ...n, ...o, ref: r });
  }
);
Z.displayName = Q;
function Pe(t, r) {
  const e = Math.abs(r.top - t.y), o = Math.abs(r.bottom - t.y), n = Math.abs(r.right - t.x), a = Math.abs(r.left - t.x);
  switch (Math.min(e, o, n, a)) {
    case a:
      return "left";
    case n:
      return "right";
    case e:
      return "top";
    case o:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Ee(t, r, e = 5) {
  const o = [];
  switch (r) {
    case "top":
      o.push(
        { x: t.x - e, y: t.y + e },
        { x: t.x + e, y: t.y + e }
      );
      break;
    case "bottom":
      o.push(
        { x: t.x - e, y: t.y - e },
        { x: t.x + e, y: t.y - e }
      );
      break;
    case "left":
      o.push(
        { x: t.x + e, y: t.y - e },
        { x: t.x + e, y: t.y + e }
      );
      break;
    case "right":
      o.push(
        { x: t.x - e, y: t.y - e },
        { x: t.x - e, y: t.y + e }
      );
      break;
  }
  return o;
}
function Re(t) {
  const { top: r, right: e, bottom: o, left: n } = t;
  return [
    { x: n, y: r },
    { x: e, y: r },
    { x: e, y: o },
    { x: n, y: o }
  ];
}
function _e(t, r) {
  const { x: e, y: o } = t;
  let n = !1;
  for (let a = 0, l = r.length - 1; a < r.length; l = a++) {
    const v = r[a].x, i = r[a].y, d = r[l].x, c = r[l].y;
    i > o != c > o && e < (d - v) * (o - i) / (c - i) + v && (n = !n);
  }
  return n;
}
function Oe(t) {
  const r = t.slice();
  return r.sort((e, o) => e.x < o.x ? -1 : e.x > o.x ? 1 : e.y < o.y ? -1 : e.y > o.y ? 1 : 0), Ae(r);
}
function Ae(t) {
  if (t.length <= 1) return t.slice();
  const r = [];
  for (let o = 0; o < t.length; o++) {
    const n = t[o];
    for (; r.length >= 2; ) {
      const a = r[r.length - 1], l = r[r.length - 2];
      if ((a.x - l.x) * (n.y - l.y) >= (a.y - l.y) * (n.x - l.x)) r.pop();
      else break;
    }
    r.push(n);
  }
  r.pop();
  const e = [];
  for (let o = t.length - 1; o >= 0; o--) {
    const n = t[o];
    for (; e.length >= 2; ) {
      const a = e[e.length - 1], l = e[e.length - 2];
      if ((a.x - l.x) * (n.y - l.y) >= (a.y - l.y) * (n.x - l.x)) e.pop();
      else break;
    }
    e.push(n);
  }
  return e.pop(), r.length === 1 && e.length === 1 && r[0].x === e[0].x && r[0].y === e[0].y ? r : r.concat(e);
}
var De = Y, Le = W, ke = X, Ie = K, Me = z, Ne = Z;
const He = "_button_30w0r_32", Se = "_content_30w0r_41", Ge = "_arrow_30w0r_76", I = {
  button: He,
  content: Se,
  arrow: Ge
}, R = ({ children: t, onOpenChange: r, open: e, ...o }) => /* @__PURE__ */ u(De, { children: /* @__PURE__ */ u(Le, { onOpenChange: r, open: e, ...o, children: t }) }), Be = ({
  "aria-label": t = "tooltip",
  asChild: r,
  children: e,
  className: o,
  onClick: n,
  ...a
}) => /* @__PURE__ */ u(ke, { "aria-label": t, asChild: !0, className: o, onClick: n, children: r ? te(e) ? e : (console.warn("Tooltip.Trigger: asChild prop requires a single valid element as children"), null) : /* @__PURE__ */ u(fe, { className: $(I.button, o), variant: "ghost", ...a, children: e || /* @__PURE__ */ u(re, { opacity: 0.6 }) }) }), Fe = ({
  children: t,
  className: r,
  ...e
}) => /* @__PURE__ */ u(Ie, { children: /* @__PURE__ */ M(
  Me,
  {
    className: $(I.content, r),
    "data-cxy-name": "tooltip",
    sideOffset: 5,
    ...e,
    children: [
      t,
      /* @__PURE__ */ u(Ne, { className: I.arrow })
    ]
  }
) });
R.Trigger = Be;
R.Content = Fe;
const Qe = ({ children: t, side: r }) => {
  const [e, o] = ee(!1);
  return /* @__PURE__ */ M(R, { onOpenChange: o, open: e, children: [
    /* @__PURE__ */ u(R.Trigger, { onClick: () => o(!e) }),
    /* @__PURE__ */ u(R.Content, { side: r, children: t })
  ] });
};
export {
  Ne as A,
  R as T,
  Qe as a
};
